export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/visual-cues-icon.svg?1c7fb255cef059f066abd7eaef800c6b";